import { render, staticRenderFns } from "./CommonVarchar.vue?vue&type=template&id=249343d6&scoped=true&"
import script from "./CommonVarchar.vue?vue&type=script&lang=ts&"
export * from "./CommonVarchar.vue?vue&type=script&lang=ts&"
import style0 from "./CommonVarchar.vue?vue&type=style&index=0&id=249343d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249343d6",
  null
  
)

export default component.exports